import * as ih from '@core_utils/util'
import { getErrorMessage } from '@core/utils/api/errorMessage';
import { generateSubcomponentDataBy } from '@core_utils/subComponent/subComponent';
import EditingSubFrame from '@core_components/admin/components/subs/editing/EditingSubFrame';
import EditingSubSubmitRequired from '@core_components/admin/components/subs/editing/element/EditingSubSubmitRequired';

const {
    SUBMIT_REQUIRED_AUTO,
    readSubmitRequired,
    applySubmitRequired
} = require('@core/mixins/submit-required-override.cjs');
const { choiceProblem } = require('@core/mixins/EditingSubComponentMixin.choices.cjs');

const uid_map = new WeakMap()
let uid_seq = 0

export const EditingSubComponentMixin = {
    props: {
        sub_code: {
            type: String,
            default: ''
        },
        label: {
            type: String,
            default: '',
        }
    },
    components: {
        EditingSubFrame,
        EditingSubSubmitRequired
    },
    data () {
        return {
            is_condition_available: false,

            sub_types: ['radio', 'checkbox', 'table', 'input_text', 'input_number', 'file_URL2', 'guide_text', 'guide_text2'],
            sub_label: this.label ?? this.sub_code,
            sub_condition_information: '선행조건을 둘 경우, 해당 체크박스를 클릭해야만 구체적인 답변을 입력할 수 있도록 제한합니다',
            sub_data_header_information: {
                checkbox: `{ "value": [] `,
                table: `{ "table_header": ["No", "이름", "독립성", "직업"]}`,
                radio: `{
                    "value": ""
                }`,
                radio_group: `{}`,
                input_text: `{ "placeholder": "텍스트를 입력해 주세요" }`,
                textbox: `{ "placeholder": "텍스트를 입력해 주세요" }`,
                input_number: `{ "placeholder": "수치를 입력해 주세요" }`,
                file: ``,
                URL: ``,
                file_URL: ``,
                file_URL2: ``,
                editable_table: `{ "table_header": ["No", "이름", "독립성", "직업"] }`,

            },
            sub_data_contents_information: {
                checkbox: `[ {"text": "예", "value": "예", "description": ""},
                    {"text": "아니오", "value": "아니오", "description": ""}]`,
                table: `[{ "No": "1", "이름": "홍길동", "독립성": "", "직업": "모름",
                    "noteditables": ["No", "이름"],
                    "dropdown": { "독립성": ["독립","비독립"] },
                    "placeholders": { "독립성": "독립성 여부를 입력해 주세요" }
                    },
                    { "No": "2", "이름": "누구", "독립성": "비독립", "직업": "모름" }]`,
                radio: `{{ "text": "예", "value": "예" },
                    { "text": "아니오", "value": "아니오"}}`,
                radio_group: `[{ "label": "대기배출량 종류", "option": [ "1층", "2층", "3층" ], "selected": "" },
                    { "label": "폐수처리", "option": [ "예", "아니오" ], "selected": "" }]`,
                input_text: `[]`,
                textbox: `[]`,
                input_number: `[]`,
                file: ``,
                URL: ``,
                file_URL: `[]`,
                file_URL2: `[]`,
                editable_table: `[{ "No": "1", "이름": "홍길동", "독립성": "", "직업": "모름",
                    "noteditables": ["No", "이름"],
                    "dropdown": { "독립성": ["독립","비독립"] },
                    "placeholders": { "독립성": "독립성 여부를 입력해 주세요" }
                    },
                    { "No": "2", "이름": "누구", "독립성": "비독립", "직업": "모름" }]`
            },
            sub_data_header_popover_show: false,
            sub_data_contents_popover_show: false,
            sub_condition_popover_show: false,

            has_child: false,
            disable_child: ['file', 'file_URL', 'file_URL2'],

            dismissSecs: 2,
            dismissCountDown: false,
            alert_msg: '',
            alert_variant: 'danger',
            
            sub_name: '',
            sub_name_e: '',
            sub_name_c: '',

            sub_description: '',
            sub_description_e: '',
            sub_description_c: '',

            sub_info: '',
            sub_info_e: '',
            sub_info_c: '',

            sub_data_header: {
                enable_na: false,
                enable_na_label: '해당없음',
                has_attachment: false, // 파일 및 URL 첨부; Subs 자체에 대한 첨부여부
                required_opt_attachment: false, // DFRadio, DFCheckbox 의 선택지(옵션)별 첨부여부
                required_attachment: false, // 첨부필수 여부
                required: false // DFGuideText의 "필수 응답(Public ONLY)" 옵션
            },

            sub_data_contents: {},
            sub_condition: '',
            sub_priority: '',

            sub_priority_option: [
                { value: '', text: ''},
                { value: '기초', text: '기초'},
                { value: '심화', text: '심화'},
                { value: '잠재', text: '잠재'}
            ],

            sub_child: [],
            sub_parent: '',
            tags: [],
            sub_risk: false,

            enable_na: false,
            enable_na_label: '해당없음',
            has_attachment: false,
            required_attachment: false,
            required_answer: false,
            required_opt_attachment: false,
            // 문항별 제출 필수 override — 'auto'(캠페인 설정 따름) / 'on' / 'off'
            submit_required: SUBMIT_REQUIRED_AUTO,

            scoring: 'No Scoring',

            idx: -1,

            type_by_structure: {
                radio: {
                    structure:[
                        {text: '예', value: '예'},
                        {text: '아니오', value: '아니오'}
                    ],
                    result: []
                },
                checkbox: {
                    structure:[
                        {text: '예', value: '예'},
                        {text: '아니오', value: '아니오'}
                    ],
                    result: []
                },
                file_URL2: {},
                guide_text: {
                    structure: ['가이드 텍스트입니다.'],
                },
                guide_text2: {
                    structure: ['가이드 텍스트입니다.'],
                },
                textbox: {
                    structure: [],
                    result: [],
                    placeholder: null
                },
                table: {
                    // 최소 한 컬럼 / 한 행만. 연도 고정값은 매년 손대야 하고, 헤더를 고치면 번역 가드에 막힌다.
                    // 행 개수도 EditingOthers.vue 의 신규 생성 기본값(1행)과 맞춘다.
                    table_header: ['구분'],
                    result: [],
                    structure: [
                        { placeholder: {}, input_type: {}, noteditables: [], dropdown: {}, calculation: {} }
                    ]
                },
                input_text: {
                    result: null,
                    placeholder: null,
                    na_reason: null
                },
                input_number: {
                    unit: null,
                    result: null,
                    placeholder: null,
                    na_reason: null
                }
            },

            is_saving_subs: false,
            // 미저장 판정 기준(편집 스냅숏). null 이면 아직 기준을 잡지 않았다
            edit_baseline: null
        }
    },
    computed: {
        sub_type () {
            return this.$store.state.question_subs[this.idx].sub_type
        },
        is_edit_dirty () {
            return this.edit_baseline !== null && this.editSnapshot() !== this.edit_baseline
        }
    },
    watch: {
        // QuestionMaster_v2 가 받아 [취소]·ESC·편집기 전환·페이지 이탈 때 묻는다
        is_edit_dirty (_dirty) {
            this.$emit('dirty', _dirty)
        },
        sub_child: {
            immediate: true,
            handler (_new_sub_child) {
                if (_new_sub_child && _new_sub_child.length !== 0) {
                    this.has_child = true
                } else {
                    this.has_child = false
                }
            }
        },
        // 문항 첨부와 선택지별 첨부는 함께 켤 수 없다(응답자 화면에 첨부 칸이 두 개 뜬다) — 하나를 켜면 다른 하나를 끈다(v2 편집기와 같은 규칙).
        // 둘 다 꺼지면 '첨부 필수' 는 뜻이 없어 끈다.
        has_attachment (_has_attachment_state) {
            if (_has_attachment_state && this.required_opt_attachment) {
                this.required_opt_attachment = false
            }

            if (!_has_attachment_state && !this.required_opt_attachment && this.required_attachment) {
                this.required_attachment = false
            }
        },
        required_opt_attachment (_required_opt_attachment_state) {
            if (_required_opt_attachment_state && this.has_attachment) {
                this.has_attachment = false
            }

            if (!this.has_attachment && !_required_opt_attachment_state && this.required_attachment) {
                this.required_attachment = false
            }
        }
    },
    created () {
        this.idx = this.$store.state.question_subs.findIndex(item => item.sub_code === this.sub_code)
        if (this.idx > -1) {
            const {
                sub_name, sub_name_e, sub_name_c,
                sub_description, sub_description_e, sub_description_c,
                sub_info, sub_info_e, sub_info_c,
                sub_condition, sub_data_header,
                sub_data_contents,
                sub_priority, sub_child, sub_parent, tags,
                risk
            } = generateSubcomponentDataBy(this.$store.state.question_subs[this.idx])

            this.sub_name = sub_name
            this.sub_name_e = sub_name_e
            this.sub_name_c = sub_name_c

            this.sub_description = sub_description
            this.sub_description_e = sub_description_e
            this.sub_description_c = sub_description_c

            this.sub_info = sub_info
            this.sub_info_e = sub_info_e
            this.sub_info_c = sub_info_c

            this.sub_condition = sub_condition
            this.sub_data_header = sub_data_header

            this.enable_na = this.sub_data_header?.enable_na === true
            this.enable_na_label = !this.sub_data_header?.enable_na ? null : this.sub_data_header?.enable_na_label || "해당없음"
            this.has_attachment = this.sub_data_header?.has_attachment === true
            this.required_attachment = this.sub_data_header?.required_attachment === true
            this.required_answer = this.sub_data_header?.required_answer === true
            this.required_opt_attachment = this.sub_data_header?.required_opt_attachment === true
            this.submit_required = readSubmitRequired(this.sub_data_header)

            if (typeof this.sub_data_header.required !== 'undefined') {
                delete this.sub_data_header['required']
            }
            
            if (this.sub_type === 'guide_text' || this.sub_type === 'guide_text2') {
                if (!this.isFieldEmpty(sub_data_contents)) {
                    let _is_structure_element_object = sub_data_contents.structure.some(_structure => typeof _structure === 'object')
                    if (_is_structure_element_object) {
                        sub_data_contents.structure = sub_data_contents.structure.map(_structure => typeof _structure === 'object' ? JSON.stringify(_structure) : _structure)
                    }
                }

                this.sub_data_contents = sub_data_contents
            } else {
                if (!this.isFieldEmpty(sub_data_contents) && sub_data_contents.structure) {
                    let _is_structure_element_string = sub_data_contents.structure.some(_structure => typeof _structure === 'string')
                    if (_is_structure_element_string) {
                        sub_data_contents.structure = sub_data_contents.structure.map(_structure => typeof _structure === 'string' ? JSON.parse(_structure) : _structure)
                    }
                } 
                this.sub_data_contents = sub_data_contents
            }

            this.sub_priority = sub_priority
            this.sub_child = sub_child
            this.sub_parent = sub_parent
            this.sub_risk = risk || false
            this.tags = typeof tags === 'object' ? tags.toString() : tags
        }

        if (this.sub_condition !== '' && this.sub_condition.text && this.sub_condition.text !== '') {
            this.is_condition_available = true
        }
    },
    mounted () {
        // 컴포넌트 created 의 보정과 첫 watcher 반영이 끝난 뒤를 기준으로 잡는다(열자마자 미저장으로 보이지 않게)
        this.$nextTick(() => {
            this.edit_baseline = this.editSnapshot()
        })
    },
    beforeDestroy () {
        // 탭/모달이 닫혀 사라지면 부모의 미저장 표시도 풀어 준다
        if (this.is_edit_dirty) this.$emit('dirty', false)
    },
    methods: {
        /** 저장 버튼이 서버로 보내는 편집 값 전부(EditingDFTable 의 표 머리말 문자열 포함) */
        editSnapshot () {
            return JSON.stringify({
                sub_label: this.sub_label,
                sub_name: this.sub_name,
                sub_description: this.sub_description,
                sub_info: this.sub_info,
                sub_condition: this.sub_condition,
                sub_data_header: this.sub_data_header,
                sub_data_contents: this.sub_data_contents,
                sub_priority: this.sub_priority,
                sub_child: this.sub_child,
                enable_na: this.enable_na,
                enable_na_label: this.enable_na_label,
                has_attachment: this.has_attachment,
                required_attachment: this.required_attachment,
                required_answer: this.required_answer,
                required_opt_attachment: this.required_opt_attachment,
                submit_required: this.submit_required,
                sub_risk: this.sub_risk,
                tags: this.tags,
                table_header: this.table_header
            })
        },
        async selectType(item) {
            try {
                this.is_saving_subs = true
                if (this.sub_type !== item) {
                    const _structure = this.sub_data_contents && this.sub_data_contents.structure
                    const _structure_count = Array.isArray(_structure) ? _structure.length : 0
                    const _element_count = Array.isArray(_structure)
                        ? _structure.reduce((sum, _s) => sum + ((_s && _s.element_contents) ? _s.element_contents.length : 0), 0)
                        : 0
                    const _ok = await this.$showModal({
                        type: 'confirm',
                        state: 'warning',
                        title: '문항 유형 변경',
                        message: `문항 유형을 '${this.sub_type}'에서 '${item}'(으)로 바꾸면 선택지/항목 ${_structure_count}개, 세부요소 ${_element_count}개와 해당없음·첨부 설정이 초기화될 수 있습니다. 변경은 저장 버튼과 무관하게 즉시 서버에 저장되며 되돌릴 수 없습니다.`
                    })
                    if (!_ok) {
                        return false
                    }
                }
                
                const new_sub = {
                    sub_type: item,
                    sub_code: this.sub_code,
                    
                    sub_name: this.sub_name,
                    sub_name_e: this.sub_name_e,
                    sub_name_c: this.sub_name_c,

                    sub_description: this.sub_description,
                    sub_description_e: this.sub_description_e,
                    sub_description_c: this.sub_description_c,

                    sub_info: this.sub_info,
                    sub_info_e: this.sub_info_e,
                    sub_info_c: this.sub_info_c,

                    sub_condition: this.sub_condition,
                    sub_data_header: this.sub_data_header,
                    sub_data_contents: this.sub_data_contents,
                    
                    sub_priority: this.sub_priority,
                    sub_child: this.sub_child,
                    sub_parent: this.sub_parent,
                    sub_risk: this.sub_risk || false,
                    tags: this.tags,
                    label: this.sub_label
                }
                
                if (!['input_text', 'input_number', 'file_URL2'].includes(item)) {
                    if (item === 'guide_text') {
                        if (new_sub.sub_data_contents.length) {
                            new_sub.sub_data_contents = typeof new_sub.sub_data_contents.structure === 'string' ? JSON.parse(new_sub.sub_data_contents.structure) : new_sub.sub_data_contents.structure
                            let _is_structure_element_object = new_sub.sub_data_contents.structure.some(_structure => _structure && typeof _structure === 'object')
                            if (_is_structure_element_object) {
                                new_sub.sub_data_contents.structure = new_sub.sub_data_contents.structure.map(_structure => typeof _structure === 'object' ? JSON.stringify(_structure) : _structure)
                            }
                        }
                    } else {
                        // input_text·file_URL2 등 지금 유형엔 structure 가 없다. 아래에서 어차피 대상 유형 기본값으로 바뀐다
                        const _structure = new_sub.sub_data_contents && new_sub.sub_data_contents.structure
                        if (Array.isArray(_structure) && _structure.some(_s => typeof _s === 'string')) {
                            new_sub.sub_data_contents.structure = _structure.map(_s => typeof _s === 'string' ? JSON.parse(_s) : _s)
                        }
                    }
                }


                if (!['radio', 'checkbox'].includes(this.sub_type) || !['radio', 'checkbox'].includes(item)) {
                    new_sub.sub_data_header = {
                        enable_na: false, enable_na_label: null,
                        has_attachment: false, required_attachment: false, required_opt_attachment: false
                    }

                    new_sub.sub_data_contents = this.type_by_structure[item]
                }

                await this.$store.dispatch('saveQuestionSub', new_sub)
                
                this.$emit('click-save')
            } catch (error) {
                if (error && error.response && error.response.status === 401) return false
                console.error('[selectType] 유형 변경 실패', { sub_code: this.sub_code, from: this.sub_type, to: item, error })
                this.$EventBus.$emit('toast-failure', '문항 유형 변경 실패', getErrorMessage(error, error && error.message ? error.message : '알 수 없는 오류'))
            } finally {
                this.is_saving_subs = false
            }
        },
        conditionPopoverToggle(x){
            if (x === true || x === false){
                this.sub_condition_popover_show = x
            }
            else {
                this.sub_condition_popover_show = !this.sub_condition_popover_show
            }
        },
        headerPopoverToggle(x){
            if (x === true || x === false){
                this.sub_data_header_popover_show = x
            }
            else {
                this.sub_data_header_popover_show = !this.sub_data_header_popover_show
            }
        },
        contentsPopoverToggle(x){
            if (x === true || x === false){
                this.sub_data_contents_popover_show = x
            }
            else {
                this.sub_data_contents_popover_show = !this.sub_data_contents_popover_show
            }
        },
        isValid(JSONString){
            return ih.isJSON(JSONString)
        },
        async handleHasChild () {
            if (this.has_child === true) {
                //Case I. 기존자식이 없고, 새로운 자식이 추가 = 새로운 차일드 컴포넌트 생성하여 붙이기
                let new_sub = {
                    sub_code: this.sub_code + '_c',
                    sub_name: null,
                    sub_type: 'file_URL2',
                    sub_condition: {},
                    sub_description: null,
                    sub_info: null,
                    sub_priority: null,
                    sub_data_header: {},
                    sub_data_contents: {},
                    tags: null,
                    sub_parent: this.sub_code,
                    sub_child: []
                }
                await this.$store.dispatch('saveQuestionSub', new_sub)
                if (typeof this.sub_child.length === 'undefined') {
                    this.sub_child = []
                }
                
                this.sub_child.push(new_sub.sub_code)
                await this.saveSub()
            } else if (this.has_child === false) {
                //Case II. 기존자식이 있고, 새로운 자식을 없앰 = 기존 차일드 컴포넌트 삭제하기
                this.sub_child = []
            }
        },
        async saveSub () {
            try {
                this.is_saving_subs = true

                this.sub_data_header.enable_na = this.enable_na
                this.sub_data_header.enable_na_label = this.enable_na_label
                this.sub_data_header.has_attachment = this.has_attachment
                this.sub_data_header.required_attachment = this.required_attachment
                this.sub_data_header.required_answer = this.required_answer
                this.sub_data_header.required_opt_attachment = this.required_opt_attachment
                // 'auto' 도 명시 전송 (/subs/init 이 키를 병합만 하므로 지우면 이전 값이 남는다)
                applySubmitRequired(this.sub_data_header, this.submit_required)
                // 보낸 시점의 값을 기준으로 삼는다(요청 중에 더 고친 내용은 미저장으로 남게)
                const _sent_snapshot = this.editSnapshot()

                const new_sub = {
                    sub_code: this.sub_code,
                    sub_type: this.sub_type,
                    sub_name: this.sub_name,
                    sub_description: this.sub_description,
                    sub_condition: this.sub_condition,
                    sub_info: this.sub_info,
                    sub_data_header: this.sub_data_header,
                    sub_data_contents: this.sub_data_contents,
                    sub_priority: this.sub_priority,
                    sub_child: this.sub_child,
                    sub_parent: '',
                    risk: this.sub_risk,
                    tags: this.tags,
                    label: this.sub_label
                }

                // 요청용 사본에만 stringify 한다(로컬 상태를 바꾸면 저장 실패 후 재시도 때 이중 인코딩된다)
                new_sub.sub_data_contents = JSON.parse(JSON.stringify(new_sub.sub_data_contents))
                if (this.sub_type === 'guide_text') {
                    new_sub.sub_data_contents.structure[0] = JSON.stringify(new_sub.sub_data_contents.structure[0])
                }

                await this.$store.dispatch('saveQuestionSub', new_sub)
                this.edit_baseline = _sent_snapshot
                return true
            } catch (error) {
                // 로그가 없으면 콘솔에 아무 흔적도 안 남아 prod 로그를 전수 조사해야 한다
                // (2026-09-04 ST4v2 사고에서 실제로 그랬다).
                console.error('[saveSub] 문항 저장 실패', { sub_code: this.sub_code, sub_type: this.sub_type, error })
                alert(`죄송합니다. 문항 저장 중 장애가 발생했습니다. 개발팀에 문의해주세요.\n사유: ${getErrorMessage(error, error && error.message ? error.message : '알 수 없는 오류')}`)
                return false
            } finally {
                this.is_saving_subs = false
            }
            
        },
        /**
         * radio/checkbox 저장 전 검사. 통과하면 true, 아니면 사유 토스트 후 false.
         * 빈 선택지는 협력사 화면에 빈 칸으로 보이고, 값이 같은 선택지는 응답을 구분할 수 없다.
         */
        validateChoices () {
            const reason = choiceProblem({
                needs_label: !!this.label,
                sub_label: this.sub_label,
                structure: this.sub_data_contents && this.sub_data_contents.structure
            })
            if (reason) this.$EventBus.$emit('toast-warning', '저장할 수 없습니다', reason)
            return !reason
        },
        /** 객체마다 고정 키를 준다(저장 데이터에 키를 넣지 않고 v-for key 로 쓰기 위함) */
        uidOf (obj) {
            if (!uid_map.has(obj)) uid_map.set(obj, ++uid_seq)
            return uid_map.get(obj)
        },
        checkAbleChild(){
            if(this.disable_child.includes(this.sub_type)) return false
            else return true
        },
        manageConditionAvailability(){
            this.$nextTick( () => {
                //Condition 체크박스를 해제하였으면
                if(this.is_condition_available != true) {
                    // $delete/$set — 미저장 판정(editSnapshot)이 바뀐 걸 알 수 있게 반응형으로
                    this.$delete(this.sub_condition, 'text')
                    this.$delete(this.sub_condition, 'value')
                }
                //condition 체크박스를 체크한 것이면
                else {
                    //기본 컨디션 상태를 false로 초기화
                    this.$set(this.sub_condition, 'value', false)
                }
            })
        },
        showAlert(alert_variant, msg) {
            this.alert_variant = alert_variant
            this.alert_msg = msg
            this.dismissCountDown = this.dismissSecs
        },
        countDownChanged(dismissCountDown) {
            this.dismissCountDown = dismissCountDown
        },
        setScoring(mode){
            if (mode === 'auto') { 
                this.scoring = 'Auto Scoring'
                this.$set(this.sub_data_header, 'scoring', 'auto')
            } else {
                this.scoring = 'No Scoring'
                this.$set(this.sub_data_header, 'scoring', 'none')
            }

        }
    }
}
